import {Component, Input} from "@angular/core";
import {CarBrand} from "./CarBrand";

@Component({
    selector: 'new-car-brand',
    styleUrls: ['./brand.scss'],
    templateUrl: './brand.html'
})
export class BrandComponent {
    @Input() brand:CarBrand;

    public websiteCliked(){
        window.open(this.brand.websiteLink, "_blank");
    }
    public configuratorCliked(){
        window.open(this.brand.configuratorLink, "_blank");
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/new-car/presentation/brand/brand.ts